module.exports = __webpack_public_path__ + "static/img/zicai.53aa684c.png";